/**
 * Every Gateway path this module calls.
 *
 * Collected here so a route change is one edit, and so a reader can see the
 * module's entire surface against the platform without grepping for string
 * literals in JSX.
 */
export const roleEndpoints = {
  list: '/v1/roles',
  create: '/v1/roles',
  detail: (roleId: string) => `/v1/roles/${encodeURIComponent(roleId)}`,
  update: (roleId: string) => `/v1/roles/${encodeURIComponent(roleId)}`,
  delete: (roleId: string) => `/v1/roles/${encodeURIComponent(roleId)}`,
} as const;
